import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getK3Scripts, setK3Scripts } from '../../actions';
import {
  Button,
  Card,
  Form,
  InputGroup,
  Row,
  Col,
  Badge,
  Spinner,
  Modal as RBModal
} from 'react-bootstrap';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { BsSearch, BsPlus, BsFilter, BsFiles, BsCode, BsTrash, BsClock, BsEye, BsPencil, BsArrowCounterclockwise } from 'react-icons/bs';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import K3ScriptCreator from './K3ScriptCreator';
import K3ScriptView from './K3ScriptView';
import K3ModalViewSource from '../../components/K3/K3ModalViewSource';
import qs from 'query-string';
import ReactDiffViewer from 'react-diff-viewer-continued';

class K3ScriptList extends Component {
  constructor(props) {
    super(props);
    // Parse filters from URL if present
    const urlFilters = qs.parse(window.location.search);
    const savedFilters = JSON.parse(localStorage.getItem('k3ScriptListFilters')) || {};
    const savedViewMode = localStorage.getItem('k3ScriptListViewMode') || 'grid';
    const savedShowFieldsGrid = JSON.parse(localStorage.getItem('k3ScriptListShowFieldsGrid')) || {
      mid: true,
      language: true,
      target: true,
      type: true,
      updatedAt: true,
      tags: true,
      version: true,
      title: true
    };
    const savedShowFieldsList = JSON.parse(localStorage.getItem('k3ScriptListShowFieldsList')) || {
      mid: true,
      language: true,
      target: true,
      type: true,
      updatedAt: true,
      tags: true,
      version: true,
      title: true
    };
    const savedColumnOrderGrid = JSON.parse(localStorage.getItem('k3ScriptListShowOrderGrid')) || [
      'title', 'mid', 'language', 'target', 'type', 'version', 'tags', 'updatedAt'
    ];
    const savedColumnOrderList = JSON.parse(localStorage.getItem('k3ScriptListShowOrderList')) || [
      'title', 'mid', 'language', 'target', 'type', 'version', 'tags', 'updatedAt'
    ];
    const savedShowCoverImageGrid = localStorage.getItem('k3ScriptListShowCoverImageGrid') === 'false' ? false : true;
    const savedShowCoverImageList = localStorage.getItem('k3ScriptListShowCoverImageList') === 'false' ? false : true;
    const savedScriptsPerPage = parseInt(localStorage.getItem('k3ScriptListScriptsPerPage')) || 20;
    const savedShowDeletedVersions = localStorage.getItem('k3script_versions_show_deleted') === 'true';
    this.state = {
      searchKeyword: urlFilters.keyword || '',
      showCreator: false,
      showViewer: false,
      selectedScript: null,
      sortBy: urlFilters.sort_by || 'updatedAt',
      sortOrder: urlFilters.sort_order || 'desc',
      filters: {
        language: urlFilters.language || '',
        execution_target: urlFilters.execution_target || '',
        script_type: urlFilters.script_type || '',
        is_template: urlFilters.is_template || ''
      },
      showSourceModal: false,
      selectedScriptForSource: null,
      showVersionsModal: false,
      selectedScriptForVersions: null,
      versions: [],
      loadingVersions: false,
      showDeletedVersions: savedShowDeletedVersions,
      viewMode: savedViewMode,
      showFieldsGrid: savedShowFieldsGrid,
      showFieldsList: savedShowFieldsList,
      showConfigModal: false,
      columnOrderGrid: null,
      columnOrderList: null,
      showCoverImageGrid: savedShowCoverImageGrid,
      showCoverImageList: savedShowCoverImageList,
      configFields: null,
      initialCustomType: null,
      initialCustomLanguage: null,
      initialCustomTarget: null,
      currentPage: parseInt(urlFilters.page) || 1,
      scriptsPerPage: savedScriptsPerPage,
      totalScripts: 0,
      showDiffModal: false,
      diffVersions: null
    };
  }

  componentDidMount() {
    this.props.getK3Scripts(this.getCurrentQuery());
    // Fetch UI config for type dropdown
    fetch(`${process.env.REACT_APP_API_URL}/api/k3doc/doc-mid-versions?doc_mid=UI_CONFIG_FIELDS_K3SCRIPT`)
      .then(response => response.json())
      .then(data => {
        if (data.data && data.data.length > 0 && data.data[0].content) {
          try {
            const configFields = JSON.parse(data.data[0].content);
            this.setState({ configFields }, this.syncInitialCustomType);
          } catch (error) {
            console.error('Error parsing config fields:', error);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching config fields:', error);
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.totalScripts !== this.props.totalScripts) {
      this.setState({ totalScripts: this.props.totalScripts });
    }
  }

  syncInitialCustomType = () => {
    const { filters, configFields } = this.state;
    if (!configFields) return;
    
    // Sync script_type
    if (configFields.script_type && filters.script_type && 
        !configFields.script_type.options.some(opt => opt.value === filters.script_type)) {
      this.setState({ initialCustomType: filters.script_type });
    } else {
      this.setState({ initialCustomType: null });
    }

    // Sync language
    if (configFields.language && filters.language && 
        !configFields.language.options.some(opt => opt.value === filters.language)) {
      this.setState(prev => ({ initialCustomLanguage: filters.language }));
    } else {
      this.setState(prev => ({ initialCustomLanguage: null }));
    }

    // Sync execution_target
    if (configFields.execution_target && filters.execution_target && 
        !configFields.execution_target.options.some(opt => opt.value === filters.execution_target)) {
      this.setState(prev => ({ initialCustomTarget: filters.execution_target }));
    } else {
      this.setState(prev => ({ initialCustomTarget: null }));
    }
  };

  formatDisplayText = (text) => {
    if (!text) return '';
    // Convert snake_case to Title Case and uppercase for target
    return text.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  formatTarget = (target) => {
    if (!target) return '';
    return target.charAt(0).toUpperCase() + target.slice(1).toLowerCase();
  };

  formatLanguage = (language) => {
    if (!language) return '';
    // Special case for C#
    if (language === 'csharp') return 'C#';
    return language.charAt(0).toUpperCase() + language.slice(1).toLowerCase();
  };

  handleSearch = (e) => {
    e.preventDefault();
    const { searchKeyword, filters } = this.state;
    const query = {
      keyword: searchKeyword.trim(),
      ...filters
    };
    if (query.is_template === '' || query.is_template === 'all') {
      delete query.is_template;
    }
    this.updateUrl(query);
    this.props.getK3Scripts(query);
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value
      }
    }), () => {
      const { searchKeyword, filters, configFields } = this.state;
      
      // Handle custom values for each filter type
      if (configFields) {
        if (name === 'script_type' && configFields.script_type) {
          if (!configFields.script_type.options.some(opt => opt.value === value)) {
            this.setState({ initialCustomType: value });
          } else {
            this.setState({ initialCustomType: null });
          }
        }
        
        if (name === 'language' && configFields.language) {
          if (!configFields.language.options.some(opt => opt.value === value)) {
            this.setState(prev => ({ initialCustomLanguage: value }));
          } else {
            this.setState(prev => ({ initialCustomLanguage: null }));
          }
        }
        
        if (name === 'execution_target' && configFields.execution_target) {
          if (!configFields.execution_target.options.some(opt => opt.value === value)) {
            this.setState(prev => ({ initialCustomTarget: value }));
          } else {
            this.setState(prev => ({ initialCustomTarget: null }));
          }
        }
      }
      
      const query = { keyword: searchKeyword?.trim(), ...filters };
      if (query.is_template === '' || query.is_template === 'all') {
        delete query.is_template;
      }
      this.updateUrl(query);
      this.props.getK3Scripts(query);
    });
  };

  handleViewScript = (script) => {
    this.setState({
      selectedScript: script,
      showViewer: true
    });
  };

  handleDeleteScript = async (script) => {
    if (window.confirm(`Are you sure you want to delete script "${script.title}"?`)) {
      try {
        const { _id, ...scriptData } = script;
        await this.props.setK3Scripts([{ ...scriptData, is_deleted: true }]);
        await this.props.getK3Scripts();
      } catch (error) {
        console.error('Error deleting script:', error);
      }
    }
  };

  handleCopyScript = async (script) => {
    try {
      // Extract number from title if exists
      const titleMatch = script.title.match(/^(.*?)\s*\((\d+)\)$/);
      let newTitle;
      if (titleMatch) {
        const baseTitle = titleMatch[1];
        const number = parseInt(titleMatch[2]) + 1;
        newTitle = `${baseTitle} (${number})`;
      } else {
        newTitle = `${script.title} (2)`;
      }

      // Create new script object
      const newScript = {
        ...script,
        title: newTitle,
        friendly_version: '',
        script_mid: `${script.script_mid}_CLONE`,
      };

      // Remove fields that should not be copied
      delete newScript._id;
      delete newScript.createdAt;
      delete newScript.updatedAt;

      await this.props.setK3Scripts([newScript], { generate_version: true });
      this.props.getK3Scripts();
    } catch (error) {
      console.error('Error copying script:', error);
    }
  };

  handleShowSource = (script) => {
    this.setState({
      selectedScriptForSource: script,
      showSourceModal: true
    });
  };

  handleHideSource = () => {
    this.setState({
      selectedScriptForSource: null,
      showSourceModal: false
    });
  };

  handleShowVersions = async (script) => {
    this.setState({
      selectedScriptForVersions: script,
      showVersionsModal: true,
      loadingVersions: true
    });

    try {
      const { showDeletedVersions } = this.state;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/k3script/script-mid-versions?script_mid=${script.script_mid}${showDeletedVersions ? '&show_deleted=true' : ''}`);
      if (response.status !== 200) {
        throw new Error('Failed to fetch versions');
      }
      const data = await response.json();
      const versions = data.data;
      this.setState({ versions, loadingVersions: false });
    } catch (error) {
      console.error('Error fetching versions:', error);
      this.setState({ loadingVersions: false });
    }
  };

  handleHideVersions = () => {
    this.setState({
      showVersionsModal: false,
      selectedScriptForVersions: null,
      versions: []
    });
  };

  handleToggleShowDeletedVersions = (e) => {
    const showDeletedVersions = e.target.checked;
    this.setState({ showDeletedVersions }, () => {
      localStorage.setItem('k3script_versions_show_deleted', showDeletedVersions);
      if (this.state.selectedScriptForVersions) {
        this.handleShowVersions(this.state.selectedScriptForVersions);
      }
    });
  };

  handleDeleteVersion = async (version) => {
    if (window.confirm(`Are you sure you want to delete version "${version.friendly_version || version.version}" of script "${version.title}"?`)) {
      try {
        await this.props.setK3Scripts([{
          _id: version._id,
          script_mid: version.script_mid,
          is_deleted: true
        }]);
        // Refresh versions list
        this.handleShowVersions(this.state.selectedScriptForVersions);
      } catch (error) {
        console.error('Error deleting version:', error);
      }
    }
  };

  handleRestoreVersion = async (version) => {
    if (window.confirm(`Are you sure you want to restore version "${version.friendly_version || version.version}" of script "${version.title}"?`)) {
      try {
        await this.props.setK3Scripts([{
          _id: version._id,
          script_mid: version.script_mid,
          is_deleted: false
        }]);
        // Refresh versions list
        this.handleShowVersions(this.state.selectedScriptForVersions);
      } catch (error) {
        console.error('Error restoring version:', error);
      }
    }
  };

  handleShowDiff = (version) => {
    const currentIndex = this.state.versions.findIndex(v => v._id === version._id);
    if (currentIndex > 0) {
      const previousVersion = this.state.versions[currentIndex - 1];
      this.setState({
        showDiffModal: true,
        diffVersions: {
          current: version,
          previous: previousVersion
        }
      });
    } else {
      alert('This is the first version. No previous version to compare with.');
    }
  };

  handleHideDiff = () => {
    this.setState({
      showDiffModal: false,
      diffVersions: null
    });
  };

  handleChangeViewMode = (mode) => {
    this.setState({ viewMode: mode });
    localStorage.setItem('k3ScriptListViewMode', mode);
  }

  handleShowConfigModal = () => {
    this.setState({ showConfigModal: true });
  }

  handleHideConfigModal = () => {
    this.setState({ showConfigModal: false });
  }

  handleChangeShowField = (e) => {
    const { name, checked } = e.target;
    if (this.state.viewMode === 'grid') {
      this.setState(prev => {
        const showFieldsGrid = { ...prev.showFieldsGrid, [name]: checked };
        localStorage.setItem('k3ScriptListShowFieldsGrid', JSON.stringify(showFieldsGrid));
        return { showFieldsGrid };
      });
    } else {
      this.setState(prev => {
        const showFieldsList = { ...prev.showFieldsList, [name]: checked };
        localStorage.setItem('k3ScriptListShowFieldsList', JSON.stringify(showFieldsList));
        return { showFieldsList };
      });
    }
  }

  getCurrentQuery = () => {
    const { searchKeyword, filters, currentPage, scriptsPerPage, sortBy, sortOrder } = this.state;
    const query = {
      keyword: searchKeyword?.trim(),
      ...filters,
      page: currentPage,
      limit: scriptsPerPage,
      sort_by: sortBy,
      sort_order: sortOrder
    };
    if (query.is_template === '' || query.is_template === 'all') {
      delete query.is_template;
    }
    return query;
  }

  updateUrl = (query) => {
    // Remove empty values
    const cleanQuery = {};
    Object.keys(query).forEach(key => {
      if (query[key] && query[key] !== '') cleanQuery[key] = query[key];
    });
    const queryString = qs.stringify(cleanQuery);
    const newUrl = `${window.location.pathname}${queryString ? '?' + queryString : ''}`;
    window.history.replaceState(null, '', newUrl);
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      const query = this.getCurrentQuery();
      this.updateUrl(query);
      this.props.getK3Scripts(query);
    });
  };

  handleScriptsPerPageChange = (e) => {
    const scriptsPerPage = parseInt(e.target.value);
    this.setState({ scriptsPerPage, currentPage: 1 }, () => {
      localStorage.setItem('k3ScriptListScriptsPerPage', scriptsPerPage);
      const query = this.getCurrentQuery();
      this.updateUrl(query);
      this.props.getK3Scripts(query);
    });
  };

  handleSortChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      const query = this.getCurrentQuery();
      this.updateUrl(query);
      this.props.getK3Scripts(query);
    });
  };

  render() {
    const { loading } = this.props;
    const {
      searchKeyword,
      showCreator,
      showViewer,
      selectedScript,
      sortBy,
      sortOrder,
      filters,
      showSourceModal,
      selectedScriptForSource,
      showVersionsModal,
      selectedScriptForVersions,
      versions,
      loadingVersions,
      viewMode,
      showFieldsGrid,
      showFieldsList,
      showConfigModal,
      columnOrderGrid,
      columnOrderList,
      showCoverImageGrid,
      showCoverImageList,
      configFields,
      initialCustomType,
      initialCustomLanguage,
      initialCustomTarget,
      currentPage,
      scriptsPerPage,
      totalScripts,
      showDeletedVersions,
      showDiffModal,
      diffVersions
    } = this.state;

    const savedColumnOrderGrid = JSON.parse(localStorage.getItem('k3ScriptListShowOrderGrid')) || [
      'title', 'mid', 'language', 'target', 'type', 'version', 'tags', 'updatedAt'
    ];
    const savedColumnOrderList = JSON.parse(localStorage.getItem('k3ScriptListShowOrderList')) || [
      'title', 'mid', 'language', 'target', 'type', 'version', 'tags', 'updatedAt'
    ];

    const configFieldsList = [
      { key: 'title', label: 'Title' },
      { key: 'mid', label: 'MID' },
      { key: 'language', label: 'Language' },
      { key: 'target', label: 'Target' },
      { key: 'type', label: 'Type' },
      { key: 'version', label: 'Version' },
      { key: 'tags', label: 'Tags' },
      { key: 'updatedAt', label: 'Updated At' },
    ];

    const showFields = viewMode === 'grid' ? this.state.showFieldsGrid : this.state.showFieldsList;
    const columnOrder = viewMode === 'grid'
      ? (columnOrderGrid || savedColumnOrderGrid)
      : (columnOrderList || savedColumnOrderList);

    let fixedColumnOrder = columnOrder;
    if (!fixedColumnOrder.includes('title')) fixedColumnOrder = ['title', ...fixedColumnOrder];

    const validKeys = configFieldsList.map(f => f.key);
    let filteredColumnOrder = fixedColumnOrder.filter(key => validKeys.includes(key));

    if (filteredColumnOrder.length !== fixedColumnOrder.length) {
      if (viewMode === 'grid') {
        localStorage.setItem('k3ScriptListShowOrderGrid', JSON.stringify(filteredColumnOrder));
      } else {
        localStorage.setItem('k3ScriptListShowOrderList', JSON.stringify(filteredColumnOrder));
      }
    }

    if (!filteredColumnOrder.includes('title')) filteredColumnOrder = ['title', ...filteredColumnOrder];
    configFieldsList.forEach(f => { if (!filteredColumnOrder.includes(f.key)) filteredColumnOrder.push(f.key); });

    const orderedFields = filteredColumnOrder
      .map(key => configFieldsList.find(f => f.key === key))
      .filter(Boolean);

    const setColumnOrder = (order) => {
      if (this.state.viewMode === 'grid') {
        this.setState({ columnOrderGrid: order });
        localStorage.setItem('k3ScriptListShowOrderGrid', JSON.stringify(order));
      } else {
        this.setState({ columnOrderList: order });
        localStorage.setItem('k3ScriptListShowOrderList', JSON.stringify(order));
      }
    };

    const showCoverImage = viewMode === 'grid' ? this.state.showCoverImageGrid : this.state.showCoverImageList;

    let listOrderedFields = [...orderedFields];
    if (viewMode === 'list') {
      if (showCoverImage && !listOrderedFields.some(f => f.key === 'cover_image')) {
        listOrderedFields = [{ key: 'cover_image', label: 'Cover Image' }, ...listOrderedFields];
      }
      if (!showCoverImage) {
        listOrderedFields = listOrderedFields.filter(f => f.key !== 'cover_image');
      }
    }

    const totalPages = Math.ceil(totalScripts / scriptsPerPage);

    return (
      <div className="container-fluid p-4">
        <Row className="mb-4 align-items-center">
          <Col md={8}>
            <Form onSubmit={this.handleSearch}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search scripts..."
                  value={searchKeyword}
                  onChange={(e) => this.setState({ searchKeyword: e.target.value })}
                />
                <Button variant="outline-secondary" type="submit">
                  <BsSearch />
                </Button>
              </InputGroup>
            </Form>
          </Col>
          <Col md={4} className="text-end">
            <Button
              variant="primary"
              onClick={() => this.setState({ showCreator: true })}
              className="me-2"
            >
              <BsPlus className="me-1" /> New Script
            </Button>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <div className="d-flex align-items-center gap-4">
              <Form.Select
                name="language"
                value={filters.language}
                onChange={this.handleFilterChange}
                className="w-auto"
              >
                <option value="">All Languages</option>
                {this.state.configFields && this.state.configFields.language ? (
                  (() => {
                    let languageOptions = this.state.configFields.language.options;
                    if (this.state.initialCustomLanguage && !languageOptions.some(opt => opt.value === this.state.initialCustomLanguage)) {
                      languageOptions = [{ value: this.state.initialCustomLanguage, label: this.state.initialCustomLanguage }, ...languageOptions];
                    }
                    return languageOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ));
                  })()
                ) : (
                  <>
                    <option value="javascript">JavaScript</option>
                    <option value="python">Python</option>
                    <option value="java">Java</option>
                    <option value="csharp">C#</option>
                  </>
                )}
              </Form.Select>

              <Form.Select
                name="execution_target"
                value={filters.execution_target}
                onChange={this.handleFilterChange}
                className="w-auto"
              >
                <option value="">All Targets</option>
                {this.state.configFields && this.state.configFields.execution_target ? (
                  (() => {
                    let targetOptions = this.state.configFields.execution_target.options;
                    if (this.state.initialCustomTarget && !targetOptions.some(opt => opt.value === this.state.initialCustomTarget)) {
                      targetOptions = [{ value: this.state.initialCustomTarget, label: this.state.initialCustomTarget }, ...targetOptions];
                    }
                    return targetOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ));
                  })()
                ) : (
                  <>
                    <option value="human">Human</option>
                    <option value="ai">AI</option>
                    <option value="system">System</option>
                    <option value="tool">Tool</option>
                    <option value="web">Web</option>
                  </>
                )}
              </Form.Select>

              <Form.Select
                name="script_type"
                value={filters.script_type}
                onChange={this.handleFilterChange}
                className="w-auto"
              >
                <option value="">All Script Types</option>
                {this.state.configFields && this.state.configFields.script_type ? (
                  (() => {
                    let typeOptions = this.state.configFields.script_type.options;
                    if (this.state.initialCustomType && !typeOptions.some(opt => opt.value === this.state.initialCustomType)) {
                      typeOptions = [{ value: this.state.initialCustomType, label: this.state.initialCustomType }, ...typeOptions];
                    }
                    return typeOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ));
                  })()
                ) : (
                  <>
                    <option value="script_runner">Script Runner</option>
                    <option value="web_agent_main_script">Web Agent Main Script</option>
                    <option value="web_agent_sub_script">Web Agent Sub Script</option>
                    <option value="general_script">General Script</option>
                  </>
                )}
              </Form.Select>

              <Form.Select
                name="is_template"
                value={filters.is_template}
                onChange={this.handleFilterChange}
                className="w-auto"
              >
                <option value="">All</option>
                <option value="false">Non-template</option>
                <option value="true">Template</option>
              </Form.Select>

              <Button
                variant="outline-info"
                className="ms-2"
                size="sm"
                onClick={this.handleShowConfigModal}
              >
                Config Show
              </Button>

              <div className="flex-grow-1"></div>

              <div className="d-flex justify-content-end align-items-center" style={{ minWidth: 90 }}>
                <Button
                  variant={this.state.viewMode === 'grid' ? 'secondary' : 'outline-secondary'}
                  className={this.state.viewMode === 'grid' ? 'me-1 border border-2 border-primary' : 'me-1'}
                  onClick={() => this.handleChangeViewMode('grid')}
                  title="Grid view"
                  style={{ padding: '0.375rem 0.75rem', minWidth: '40px' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-grid-3x3-gap-fill" viewBox="0 0 16 16">
                    <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM2 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm6-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm-9 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm6-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"/>
                  </svg>
                </Button>
                <Button
                  variant={this.state.viewMode === 'list' ? 'secondary' : 'outline-secondary'}
                  className={this.state.viewMode === 'list' ? 'border border-2 border-primary' : ''}
                  onClick={() => this.handleChangeViewMode('list')}
                  title="List view"
                  style={{ padding: '0.375rem 0.75rem', minWidth: '40px' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M2.5 12.5A.5.5 0 0 1 3 12h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 8h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 4h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                  </svg>
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <div className="text-muted">
                Found {totalScripts} {totalScripts === 1 ? 'script' : 'scripts'}
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted">Sort by:</span>
                  <Form.Select
                    name="sortBy"
                    value={this.state.sortBy}
                    onChange={this.handleSortChange}
                    className="w-auto"
                  >
                    <option value="updatedAt">Updated At</option>
                    <option value="createdAt">Created At</option>
                    <option value="title">Title</option>
                    <option value="type">Type</option>
                    <option value="version">Version</option>
                  </Form.Select>
                  <Form.Select
                    name="sortOrder"
                    value={this.state.sortOrder}
                    onChange={this.handleSortChange}
                    className="w-auto"
                  >
                    <option value="asc">Ascending</option>
                    <option value="desc">Descending</option>
                  </Form.Select>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted">Scripts per page:</span>
                  <Form.Select
                    value={scriptsPerPage}
                    onChange={this.handleScriptsPerPageChange}
                    style={{ width: 'auto' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </Form.Select>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center p-5">
            <Spinner animation="border" />
          </div>
        ) : (
          this.state.viewMode === 'grid' ? (
            <Row>
              {this.props.scripts.map(script => (
                <Col key={script._id} lg={3} md={4} sm={6} className="mb-4">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <div className="position-relative">
                        {showCoverImage && script.cover_image && (
                          <img
                            src={script.cover_image}
                            alt="cover"
                            style={{ maxWidth: '100%', maxHeight: 120, display: 'block', margin: '0 auto 8px auto', borderRadius: 6, cursor: 'pointer' }}
                            onClick={() => this.handleViewScript(script)}
                          />
                        )}
                        {script.is_template && (
                          <Badge 
                            bg="warning" 
                            className="position-absolute top-0 end-0 m-2"
                            style={{ zIndex: 1 }}
                          >
                            Template
                          </Badge>
                        )}
                        {showFields['title'] !== false && (
                          <Card.Title 
                            className="text-truncate mb-2" 
                            title={`${script.title}\n\n${script.description || ''}`}
                          >
                            <h5>{script.title}</h5>
                          </Card.Title>
                        )}
                      </div>
                      <div className="small text-muted mb-2">
                        {orderedFields.map(f => showFields[f.key] !== false && (
                          <div key={f.key}>
                            {f.key === 'mid' && <span>MID: {script.script_mid}</span>}
                            {f.key === 'language' && <span>Language: {this.formatLanguage(script.language)}</span>}
                            {f.key === 'target' && <span>Target: {this.formatTarget(script.execution_target)}</span>}
                            {f.key === 'type' && <span>Type: {this.formatDisplayText(script.script_type)}</span>}
                            {f.key === 'version' && <span>Version: {script.friendly_version || script.version}</span>}
                            {f.key === 'updatedAt' && <span>Updated: {script.updatedAt ? new Date(script.updatedAt).toLocaleString() : ''}</span>}
                            {f.key === 'tags' && script.tags && script.tags.length > 0 && (
                              <span>
                                Tags: {script.tags.map(tag => (
                                  <Badge pill key={tag} bg="success" className="me-1 mb-1">{tag}</Badge>
                                ))}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="d-flex justify-content-center gap-3">
                        <BsEye 
                          className="sidebar-icon" 
                          size={20}
                          onClick={() => this.handleViewScript(script)}
                          style={{ cursor: 'pointer' }}
                          title="View Script"
                        />
                        <BsPencil 
                          className="sidebar-icon" 
                          size={20}
                          onClick={() => this.handleViewScript(script)}
                          style={{ cursor: 'pointer' }}
                          title="Edit Script"
                        />
                        <BsClock 
                          className="sidebar-icon" 
                          size={20}
                          onClick={() => this.handleShowVersions(script)}
                          style={{ cursor: 'pointer' }}
                          title="View Versions"
                        />
                        <BsCode 
                          className="sidebar-icon" 
                          size={20}
                          onClick={() => this.handleShowSource(script)}
                          style={{ cursor: 'pointer' }}
                          title="View Source"
                        />
                        <BsFiles 
                          className="sidebar-icon" 
                          size={20}
                          onClick={() => this.handleCopyScript(script)}
                          style={{ cursor: 'pointer' }}
                          title="Clone Script"
                        />
                        <BsTrash 
                          className="sidebar-icon" 
                          size={20}
                          onClick={() => this.handleDeleteScript(script)}
                          style={{ cursor: 'pointer' }}
                          title="Delete Script"
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead>
                  <tr>
                    {listOrderedFields.map(f => showFields[f.key] !== false && <th key={f.key}>{f.label}</th>)}
                    <th style={{ minWidth: 120 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.scripts.map(script => (
                    <tr key={script._id}>
                      {listOrderedFields.map(f => (
                        <td key={f.key}>
                          {f.key === 'cover_image' && showCoverImageList && script.cover_image && (
                            <div className="position-relative">
                              <img 
                                src={script.cover_image} 
                                alt="cover" 
                                style={{ maxWidth: 80, maxHeight: 80, borderRadius: 4, cursor: 'pointer' }} 
                                onClick={() => this.handleViewScript(script)}
                              />
                              {script.is_template && (
                                <Badge 
                                  bg="warning" 
                                  className="position-absolute top-0 end-0"
                                  style={{ transform: 'translate(25%, -25%)' }}
                                >
                                  Template
                                </Badge>
                              )}
                            </div>
                          )}
                          {f.key === 'title' && showFieldsList.title !== false && script.title}
                          {f.key === 'mid' && showFieldsList.mid !== false && script.script_mid}
                          {f.key === 'language' && showFieldsList.language !== false && this.formatLanguage(script.language)}
                          {f.key === 'target' && showFieldsList.target !== false && this.formatTarget(script.execution_target)}
                          {f.key === 'type' && showFieldsList.type !== false && this.formatDisplayText(script.script_type)}
                          {f.key === 'version' && showFieldsList.version !== false && (script.friendly_version || script.version)}
                          {f.key === 'tags' && showFieldsList.tags !== false && script.tags?.map(tag => (
                            <Badge pill key={tag} bg="success" className="me-1 mb-1">{tag}</Badge>
                          ))}
                          {f.key === 'updatedAt' && showFieldsList.updatedAt !== false && (script.updatedAt ? new Date(script.updatedAt).toLocaleString() : '')}
                        </td>
                      ))}
                      <td>
                        <div className="d-flex gap-2">
                          <BsEye 
                            className="sidebar-icon" 
                            size={20}
                            onClick={() => this.handleViewScript(script)}
                            style={{ cursor: 'pointer' }}
                            title="View Script"
                          />
                          <BsPencil 
                            className="sidebar-icon" 
                            size={20}
                            onClick={() => this.handleViewScript(script)}
                            style={{ cursor: 'pointer' }}
                            title="Edit Script"
                          />
                          <BsClock 
                            className="sidebar-icon" 
                            size={20}
                            onClick={() => this.handleShowVersions(script)}
                            style={{ cursor: 'pointer' }}
                            title="View Versions"
                          />
                          <BsCode 
                            className="sidebar-icon" 
                            size={20}
                            onClick={() => this.handleShowSource(script)}
                            style={{ cursor: 'pointer' }}
                            title="View Source"
                          />
                          <BsFiles 
                            className="sidebar-icon" 
                            size={20}
                            onClick={() => this.handleCopyScript(script)}
                            style={{ cursor: 'pointer' }}
                            title="Clone Script"
                          />
                          <BsTrash 
                            className="sidebar-icon" 
                            size={20}
                            onClick={() => this.handleDeleteScript(script)}
                            style={{ cursor: 'pointer' }}
                            title="Delete Script"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}

        {/* Add pagination at the bottom */}
        {totalPages > 1 && (
          <Row className="mt-4">
            <Col>
              <div className="d-flex justify-content-center">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => this.handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    {[...Array(totalPages)].map((_, index) => (
                      <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => this.handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => this.handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </Col>
          </Row>
        )}

        {showCreator && (
          <K3ScriptCreator
            show={showCreator}
            onHide={() => this.setState({ showCreator: false })}
          />
        )}

        {showViewer && selectedScript && (
          <K3ScriptView
            show={showViewer}
            onHide={() => this.setState({ showViewer: false, selectedScript: null })}
            selectedScript={selectedScript}
          />
        )}

        <K3ModalViewSource
          show={showSourceModal}
          onHide={this.handleHideSource}
          data={selectedScriptForSource}
          title="Script Source"
        />

        <Modal isOpen={showVersionsModal} toggle={this.handleHideVersions} className="modal-xl" style={{ 
          maxWidth: '90vw',
          margin: '0 auto'
        }}>
          <ModalHeader toggle={this.handleHideVersions}>
            Version History - {selectedScriptForVersions?.title}
          </ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <Form.Check
                type="checkbox"
                id="showDeletedVersions"
                label="Show Deleted Versions"
                checked={showDeletedVersions}
                onChange={this.handleToggleShowDeletedVersions}
              />
            </div>
            {loadingVersions ? (
              <div className="text-center p-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Version</th>
                      <th>Friendly Version</th>
                      <th style={{ maxWidth: '200px' }}>Version Note</th>
                      <th>Title</th>
                      <th>Created At</th>
                      {showDeletedVersions && <th>Deleted</th>}
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {versions.map((version, index) => (
                      <tr key={index}>
                        <td>{version._id}</td>
                        <td>{version.version}</td>
                        <td>{version.friendly_version}</td>
                        <td style={{ maxWidth: '200px' }} className="text-truncate" title={version.version_note}>
                          {version.version_note}
                        </td>
                        <td>{version.title}</td>
                        <td>{new Date(version.createdAt).toLocaleString()}</td>
                        {showDeletedVersions && (
                          <td>
                            {version.is_deleted ? (
                              <Badge bg="danger">Deleted</Badge>
                            ) : (
                              <Badge bg="success">Active</Badge>
                            )}
                          </td>
                        )}
                        <td>
                          <div className="d-flex gap-2">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => this.handleViewScript(version)}
                              className="me-2"
                            >
                              <BsPencil className="me-1" /> Edit
                            </Button>
                            <Button
                              variant="outline-info"
                              size="sm"
                              onClick={() => this.handleViewScript(version)}
                              className="me-2"
                            >
                              <BsEye className="me-1" /> Read
                            </Button>
                            {!version.is_deleted ? (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => this.handleDeleteVersion(version)}
                                className="me-2"
                              >
                                <BsTrash className="me-1" /> Delete
                              </Button>
                            ) : (
                              <Button
                                variant="outline-success"
                                size="sm"
                                onClick={() => this.handleRestoreVersion(version)}
                                className="me-2"
                              >
                                <BsArrowCounterclockwise className="me-1" /> Restore
                              </Button>
                            )}
                            {index > 0 && !version.is_deleted && (
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => this.handleShowDiff(version)}
                              >
                                <BsCode className="me-1" /> Diff
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="secondary" onClick={this.handleHideVersions}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

        {/* Add Diff Modal */}
        <Modal isOpen={showDiffModal} toggle={this.handleHideDiff} className="modal-xl" style={{ 
          maxWidth: '90vw',
          margin: '0 auto'
        }}>
          <ModalHeader toggle={this.handleHideDiff}>
            Compare Versions
          </ModalHeader>
          <ModalBody>
            {diffVersions && (
              <div>
                <div className="mb-3">
                  <div className="row">
                    <div className="col-6">
                      <h5>Previous Version</h5>
                      <div className="text-muted small">
                        <div>Version: {diffVersions.previous.friendly_version || diffVersions.previous.version}</div>
                        <div>Created: {new Date(diffVersions.previous.createdAt).toLocaleString()}</div>
                        <div>Title: {diffVersions.previous.title}</div>
                        {diffVersions.previous.version_note && (
                          <div>Note: {diffVersions.previous.version_note}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <h5>Current Version</h5>
                      <div className="text-muted small">
                        <div>Version: {diffVersions.current.friendly_version || diffVersions.current.version}</div>
                        <div>Created: {new Date(diffVersions.current.createdAt).toLocaleString()}</div>
                        <div>Title: {diffVersions.current.title}</div>
                        {diffVersions.current.version_note && (
                          <div>Note: {diffVersions.current.version_note}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
                  <ReactDiffViewer
                    oldValue={diffVersions.previous.script_code || ''}
                    newValue={diffVersions.current.script_code || ''}
                    splitView={true}
                    showDiffOnly={false}
                    leftTitle="Previous Version"
                    rightTitle="Current Version"
                    styles={{
                      variables: {
                        light: {
                          diffViewerBackground: '#f8f9fa',
                          diffViewerTitleBackground: '#e9ecef',
                          addedBackground: '#e6ffed',
                          addedColor: '#24292e',
                          removedBackground: '#ffebe9',
                          removedColor: '#24292e',
                          wordAddedBackground: '#acf2bd',
                          wordRemovedBackground: '#fdb8c0',
                        },
                      },
                    }}
                  />
                </div>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="secondary" onClick={this.handleHideDiff}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

        <RBModal show={this.state.showConfigModal} onHide={this.handleHideConfigModal}>
          <RBModal.Header closeButton>
            <RBModal.Title>
              Chọn trường hiển thị & Thứ tự cột ({viewMode === 'grid' ? 'Grid' : 'List'})
            </RBModal.Title>
          </RBModal.Header>
          <RBModal.Body>
            <div className="mb-2 text-muted small">Kéo thả để đổi thứ tự cột. Actions luôn ở cuối. (Config cho chế độ {viewMode === 'grid' ? 'Grid' : 'List'})</div>
            <Form>
              <DragDropContext onDragEnd={result => {
                if (!result.destination) return;
                const newOrder = Array.from(filteredColumnOrder);
                const [removed] = newOrder.splice(result.source.index, 1);
                newOrder.splice(result.destination.index, 0, removed);
                setColumnOrder(newOrder);
              }}>
                <Droppable droppableId="fields-droppable">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {orderedFields.filter(f => f && f.key).map((f, idx) => (
                        <Draggable key={f.key} draggableId={f.key} index={idx}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={snapshot.isDragging ? 'bg-light p-1 rounded mb-1' : 'p-1 mb-1'}
                            >
                              <Form.Check
                                type="checkbox"
                                label={f.label}
                                name={f.key}
                                checked={showFields && f && f.key ? (showFields[f.key] !== false) : true}
                                onChange={this.handleChangeShowField}
                              />
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              <div className="mb-2">
                <Form.Check type="checkbox" label="Actions" checked disabled className="fw-bold" />
              </div>
              <div className="mt-2 text-muted small">(Actions luôn ở cuối, có thể ẩn Title nếu muốn)</div>
            </Form>
            <Form.Check
              type="checkbox"
              label="Cover Image"
              checked={viewMode === 'grid' ? showCoverImageGrid : showCoverImageList}
              onChange={e => {
                const checked = e.target.checked;
                if (viewMode === 'grid') {
                  this.setState({ showCoverImageGrid: checked });
                  localStorage.setItem('k3ScriptListShowCoverImageGrid', checked);
                } else {
                  this.setState({ showCoverImageList: checked });
                  localStorage.setItem('k3ScriptListShowCoverImageList', checked);
                }
              }}
              className="mb-2"
            />
          </RBModal.Body>
          <RBModal.Footer>
            <Button variant="secondary" onClick={this.handleHideConfigModal}>Close</Button>
          </RBModal.Footer>
        </RBModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  scripts: state.k3scriptReducer.scripts,
  loading: state.k3scriptReducer.loading,
  totalScripts: state.k3scriptReducer.totalScripts
});

export default connect(mapStateToProps, { getK3Scripts, setK3Scripts })(K3ScriptList); 